var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTable',{ref:"table",attrs:{"module":"assetsHistory","hide-title":true,"headers":_vm.headers,"elevation":0,"sortby":"logged_at"}})}
var staticRenderFns = []

export { render, staticRenderFns }